import Vue from 'vue'
import './plugins/bootstrap-vue'
import i18n from './plugins/vue-i18n'

import App from './App'
import router from './router'
import store from './store/store'

import * as Sentry from "@sentry/vue";

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import Pagination from './components/Pagination'
import { BootstrapVue, BIconPencilSquare, BIconSearch, BIconXCircleFill } from 'bootstrap-vue'
import constants from '../src/mixins/constants'

library.add(faInfoCircle)

Vue.config.productionTip = false

Vue.config.errorHandler = (msg, vm, info) => {
  console.error(`Error in component ${vm.$options.name} (${info}): ${msg}`)
}

Vue.prototype.$scrollToTop = () => window.scrollTo(0,0)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component("pagination", Pagination)

Vue.use(BootstrapVue)
Vue.component('BIconPencilSquare', BIconPencilSquare)
Vue.component('BIconSearch', BIconSearch)
Vue.component('BIconXCircleFill', BIconXCircleFill)
Vue.mixin(constants)

const isProdMode = process.env.NODE_ENV === 'production'

Sentry.init({
  Vue,
  dsn: "https://1562dc55171841f0b41e607ce039c15f@o239822.ingest.sentry.io/4504452179099648",
  environment: process.env.VUE_APP_ENVIRONMENT,
  release: process.env.VUE_APP_RELEASE,
  logErrors: true,
  beforeSend(event, hint) {
    const error = hint?.originalException;
    if (error?.response?.status === 404) {
      return null;
    }
    return event;
  },
});

Sentry.getCurrentHub().getClient().getOptions().enabled = isProdMode;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
